(function () {
    'use strict';

    angular.module('skillsApp')
        .factory('cgbusyService', cgbusyService);

    function cgbusyService(
        $rootScope) {

        var tempPromises = [];

        //TODO: rename to dataPromises
        $rootScope.dataPromise = [];

        return ({
            blockUI: blockUI,
        });

        function blockUI(promise) {

            function isNotFulfilled(value) {
                return !value.$cgBusyFulfilled;
            }
            var filtered = $rootScope.dataPromise.filter(isNotFulfilled);

            filtered.push(promise);

            $rootScope.dataPromise = filtered;
            $rootScope.$broadcast('dataPromiseChanged');
            //Return the promise so we can chain
            return promise;
        }

    }

})();